import { render, staticRenderFns } from "./PersonGroupForm.vue?vue&type=template&id=77365455&"
import script from "./PersonGroupForm.vue?vue&type=script&lang=js&"
export * from "./PersonGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77365455')) {
      api.createRecord('77365455', component.options)
    } else {
      api.reload('77365455', component.options)
    }
    module.hot.accept("./PersonGroupForm.vue?vue&type=template&id=77365455&", function () {
      api.rerender('77365455', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chooseSeat/Person/modules/PersonGroupForm.vue"
export default component.exports